module.exports = __webpack_public_path__ + "img/mesa_el_o.c58165e9.png";